import s from './actions-wrapper.module.scss'

export const ActionsWrapper = ({ children }) => (
	<div className={s.actionsWrapper}>
		{children}
	</div>
)

export const AuthAction = ({ children }) => (
	<p className={s.action}>
		{children}
	</p>
)
